import { AntCheckbox } from './styles'

export default AntCheckbox
